import { Bone, SkeletonPulse } from "@/src/components/ui-kit/skeleton";
import { View } from "react-native";

type FeedbackCardSkeletonProps = Readonly<{
  /** Admin cards carry an "Anonymous" label and a Mark resolved button;
   *  a member's own cards have neither, just a status pill. */
  variant: "admin" | "mine";
}>;

/** Mirrors FeedbackCard / the rows of WikiMyFeedbackList. */
const FeedbackCardSkeleton = ({ variant }: FeedbackCardSkeletonProps) => (
  <View className="flex-col gap-3 p-3 md:border md:border-ash-3 rounded-xl">
    {variant === "admin" && <Bone className="h-4 w-24" />}

    <View className="gap-2 bg-ash px-4 py-3 rounded-xl">
      <Bone className="h-3 w-full" />
      <Bone className="h-3 w-2/3" />
    </View>

    <View className="flex-row items-center justify-between">
      <Bone className="h-3 w-20" />
      {variant === "admin" ? (
        <Bone className="h-8 w-32 rounded-2xl" />
      ) : (
        <Bone className="h-6 w-20 rounded-full" />
      )}
    </View>
  </View>
);

type FeedbackListSkeletonProps = FeedbackCardSkeletonProps &
  Readonly<{ count?: number }>;

export const FeedbackListSkeleton = ({
  variant,
  count = 3,
}: FeedbackListSkeletonProps) => (
  <SkeletonPulse testID={`feedback-list-skeleton-${variant}`}>
    <View className="gap-3">
      {variant === "admin" ? (
        // Pending / Resolved filter pills
        <View className="flex-row gap-1">
          <Bone className="h-7 w-24 rounded-full" />
          <Bone className="h-7 w-24 rounded-full" />
        </View>
      ) : (
        // "My feedback" heading
        <Bone className="h-4 w-28 mt-4" />
      )}
      <View className="gap-2">
        {Array.from({ length: count }, (_, i) => (
          <FeedbackCardSkeleton key={i} variant={variant} />
        ))}
      </View>
    </View>
  </SkeletonPulse>
);

export default FeedbackCardSkeleton;
